import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FinancialTransaction } from '../../../shared/models/financial-transaction.model';

@Component({
  selector: 'app-financial-transaction-details',
  templateUrl: './financial-transaction-details.component.html',
  styleUrls: ['./financial-transaction-details.component.scss']
})
export class FinancialTransactionDetailsComponent implements OnInit {

  @Input() currentObject: FinancialTransaction;
  @Output() afterSubmitEvent = new EventEmitter<object>();

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.activeModal.close();
    this.afterSubmitEvent.emit();
  }
}
